import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const PosAuthContext = createContext(null);

export const PosAuthProvider = ({ children }) => {
  const [posUser, setPosUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const res = await axios.get('/api/pos/auth/me', {
        withCredentials: true,
      });

      const data = res.data || {};

      if (data.ok && data.is_seller === true) {
        setPosUser({
          is_seller: true,
          seller_id: data.seller_id ?? null,
          seller_username: data.seller_username ?? '',
          shop_id: data.shop_id ?? null,
          shop_name: data.shop_name ?? '',
          redirect: data.redirect || '/pos',
        });
      } else {
        setPosUser(null);
      }
    } catch (err) {
      setPosUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (username, password) => {
    try {
      const fd = new URLSearchParams();
      fd.append('username', username);
      fd.append('password', password);

      const res = await axios.post('/pos/manage', fd, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const data = res.data || {};

      if (data.success) {
        await fetchMe();
      }

      return data;
    } catch (err) {
      return (
        err.response?.data || {
          success: false,
          message: 'POS 로그인 중 오류가 발생했습니다.',
        }
      );
    }
  };

  const logout = async () => {
    try {
      const res = await axios.post(
        '/api/pos/logout',
        {},
        { withCredentials: true }
      );

      const data = res.data || {};
      setPosUser(null);
      return data;
    } catch (err) {
      setPosUser(null);
      return (
        err.response?.data || {
          ok: false,
          error: '로그아웃 중 오류가 발생했습니다.',
        }
      );
    }
  };

  const value = {
    posUser,
    isPosSeller: !!posUser?.is_seller,
    loading,
    login,
    logout,
    refreshPosAuth: fetchMe,
  };

  return (
    <PosAuthContext.Provider value={value}>
      {children}
    </PosAuthContext.Provider>
  );
};

export const usePosAuth = () => {
  const context = useContext(PosAuthContext);

  if (!context) {
    throw new Error('usePosAuth must be used within a PosAuthProvider');
  }

  return context;
};

export default PosAuthContext;